import { Formik } from "formik";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Form, Alert } from "react-bootstrap";
import { GET_APP_ROLES} from "../../../../queries";
import DwQueryClient from '../../../../data/DwQueryClient';
import { InviteUser } from '../../../../data/Query';
//import { addUser } from "../../../../utils";
// Interface with parent
//
interface OrgUsers {
    shouldRefreshUsers: Function
}

const RegisterForm = (props: any) => {
    const [userRoles, setUserRoles] = useState<any>(null);

    const [showAdded, setShowAdded] = useState<any>(false);
    const [showNoUser, setShowNoUser] = useState<any>(false);

    console.log(props);

    useEffect(() => {
        (async function fetchData() {
            const resultRoles:any = await loadRoles();
            setUserRoles(resultRoles.data.syncarto_app_role);
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const loadRoles = () => {
        return props.client.query({
            query: GET_APP_ROLES,
            variables: {},
            optimisticResponse: null
        });
    }

    async function queryData(query: InviteUser) {
        const api = new DwQueryClient(process.env.REACT_APP_CHATBOT_URL!);

        try {
            return await api.doInviteUserQuery(query);
        } catch(e) {
            console.error(e);
        }

        return null;
    }
    // Get user name and id        
    const getUserByEmail = async (email: string) => {
        //let serverUrl = process.env.REACT_APP_CHATBOT_URL!;
        //let result = await addUser(email, props.orgId, serverUrl);
        let query = new InviteUser(email,props.orgId)
        let result = await queryData(query);
        console.log("021822 result", result);
        if (result.message){
            console.log(result.message);
            // User with this email does not exist - redirect to "create user" form for further action
            // 
            setShowNoUser(true);

            setTimeout(() => {
                setShowNoUser(false);
                props.addNewDCUser(email);
            },3500);
        }else{
            // User with this email exists - the same response from API will occur regardless of whether the user already existed or if it was a new add
            //
            setShowAdded(true);

            const { shouldRefreshUsers } = props;
            shouldRefreshUsers();

            setTimeout(() => {
                setShowAdded(false);
                props.onSelectedUserId(result.user_id);
            },3500);
        }
    }


    if(userRoles == null) {
        return (
            <div>Loading...</div>
        )
    }

    const validateEmail = (values:any) => {
        var errors: {[k: string]: any} = {};

        console.log(values);
        
        if (values.email === "") {
          errors.email = 'Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(values.email)) {
          errors.email = 'Invalid email address';
        }
        return errors;
    }

    return (
        <Formik 
            initialValues= {{ 
                email:"", 
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validate={validateEmail}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
                setSubmitting(true);
                console.log("Finding User...");
                try {
                    await getUserByEmail(values.email);
                } catch(e) {
                    console.error(e);
                    if(e.code) {
                        alert(e.message);
                    }
                }
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <>
                <h4>Add User</h4>
                <Form noValidate onSubmit={handleSubmit} autoComplete="off" style={{marginTop: "10px", padding:"1em"}}>
                    <Form.Group controlId="formEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            placeholder="Enter email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.email}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button
                        style={{marginBottom: "15px"}}
                        variant="primary"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        Add User
                    </Button>                                      
                    <Alert show={showAdded} variant="success" className="query-success-syncarto">
                        User Added! ...Redirecting to edit user form.
                    </Alert>                    
                    <Alert show={showNoUser} variant="warning" className="query-success-syncarto">
                        No user with this email! ...Redirecting to create user form.
                    </Alert>

                </Form>
                </>
          )}
        </Formik>
    );
}

export default RegisterForm;